import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-film-line text-xl text-primary-500"></i>
              </div>
              <span className="text-lg font-bold font-heading text-foreground-50">四虎影视</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              四虎影视大全致力于为广大影迷提供最新、最全的电影资讯与观影指南。海量电影资源，涵盖各类题材，无需付费，畅享电影盛宴。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">电影分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/category/dongzuo" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">热门电影</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-xs"></i>
                </div>
                <span>contact@sihumovies.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-xs"></i>
                </div>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line text-xs"></i>
                </div>
                <span>北京市朝阳区影视产业园A座</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2026 四虎影视大全. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-300 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-300 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}